/*function rand(min: number, max: number) {
  return Math.floor(Math.random() * (max - min)) + min;
}*/

export const randomImg = [
  { imageurl: "https://loremflickr.com/500/500/food" },
  { imageurl: "https://loremflickr.com/500/500/dish" },
  { imageurl: "https://loremflickr.com/500/500/cuisine" },
  { imageurl: "https://loremflickr.com/500/500/cook" },
  { imageurl: "https://loremflickr.com/500/500/meal" },
  { imageurl: "https://loremflickr.com/500/500/taste" },
  { imageurl: "https://loremflickr.com/500/500/delicious" },
  { imageurl: "https://loremflickr.com/500/500/food1" },
  { imageurl: "https://loremflickr.com/500/500/dish1" },
  { imageurl: "https://loremflickr.com/500/500/cuisine1" },
  { imageurl: "https://loremflickr.com/500/500/cook1" },
  { imageurl: "https://loremflickr.com/500/500/meal1" },
  { imageurl: "https://loremflickr.com/500/500/taste1" },
  { imageurl: "https://loremflickr.com/500/500/delicious1" },
  { imageurl: "https://loremflickr.com/500/500/food2" },
  { imageurl: "https://loremflickr.com/500/500/dish2" },
  { imageurl: "https://loremflickr.com/500/500/cuisine2" },
  { imageurl: "https://loremflickr.com/500/500/cook2" },
  { imageurl: "https://loremflickr.com/500/500/meal2" },
  { imageurl: "https://loremflickr.com/500/500/taste2" },
  { imageurl: "https://loremflickr.com/500/500/delicious2" },
  { imageurl: "https://loremflickr.com/500/500/food3" },
  { imageurl: "https://loremflickr.com/500/500/dish3" },
  { imageurl: "https://loremflickr.com/500/500/cuisine3" },
  { imageurl: "https://loremflickr.com/500/500/cook3" },
  { imageurl: "https://loremflickr.com/500/500/meal3" },
  { imageurl: "https://loremflickr.com/500/500/taste3" },
  { imageurl: "https://loremflickr.com/500/500/delicious3" },
  { imageurl: "https://loremflickr.com/500/500/food4" },
  { imageurl: "https://loremflickr.com/500/500/dish4" },
  { imageurl: "https://loremflickr.com/500/500/cuisine4" },
  { imageurl: "https://loremflickr.com/500/500/cook4" },
  { imageurl: "https://loremflickr.com/500/500/meal4" },
  { imageurl: "https://loremflickr.com/500/500/taste4" },
  { imageurl: "https://loremflickr.com/500/500/delicious4" },
];
